import React from 'react';
import { SectionContainer } from '../../../SectionContainer';
import { ApiDisplay } from '../../../ApiDisplay';
import { CustomLink } from '../../../PageElements/CustomLink';
import { APPEARANCES, Heading } from '../../../PageElements/Heading';
import { Text } from '../../../PageElements/Text';
import style from './StatusCodeNote.scss';

export const StatusCodeNote = () => {
  return (
    <SectionContainer>
      <Heading
        dataHook="status-code-note"
        appearance={APPEARANCES.H3}
        className={style.title}
      >
        Status/Error Codes
      </Heading>
      <ApiDisplay.RpcRest matchInitialType>
        <Text>
          The response will include a{' '}
          <a
            href="https://bo.wix.com/wix-docs/rnd/platformization-guidelines/errors#platformization-guidelines_errors_errors"
            target="_blank"
            rel="noopener noreferrer"
          >
            gRPC/HTTP status code
          </a>
          .
        </Text>
      </ApiDisplay.RpcRest>
      <ApiDisplay.REST matchInitialType>
        <Text>
          The response will include an{' '}
          <CustomLink to="/getting-started/errors">HTTP status code</CustomLink>
          .
        </Text>
      </ApiDisplay.REST>
    </SectionContainer>
  );
};
